import React, { useState } from 'react';
import { StatOptions } from 'fs';
import {IDNameDescriptionItem,IDNameDescriptionDictionary} from '../models/Site'
import './_IDNameDescriptionItemSelect.css'


export type Option ={
  Value:string,
  Text:string,
 
}

type Props = {
    Value:any|null,
    Options:Option[]|null,
    Id:string,
    OnChange:any,
    ClassName:string
    Disabled?: boolean;
    readonly?: boolean;
    simulatorData?:any,
  };

  
  

export class DynamicSelect extends React.Component<Props>
{
    
    constructor(props:any) {
        super(props); 
        this.handleChange.bind(this);
              
      }
      componentDidMount(){

        
        const options:IDNameDescriptionItem[] = [];
      }


      handleChange = (event:any) => {
        
        var selectedValue= event.currentTarget.selectedOptions[0].value;
        this.props.OnChange(this.props.Id,selectedValue);
      }

      
    render() {
      return (   
        <select value={this.props.Value}
        id={this.props.Id}
        onChange={this.handleChange}
        className = {this.props.ClassName}
        disabled={this.props.Disabled || this.props.simulatorData != null}
        >
          {this.props.Options?this.props.Options.map((o, i)=><option key={i} value={o.Value}>{o.Text}</option>):""}
          
        </select>
        
      );
    }
  }
